import React from 'react'
import Breadcrumb from "app/components/Breadcrumb";
import useTranslationshome from './Hometransalte'
import { Row, Col } from "react-bootstrap";
import { useLanguage } from 'app/contexts/LanguageContext';
import useCampaignQuarterlyList, { useCampaignEnrollmentCounts, cell, localizedName, formatRange } from './useCampaignQuarterlyList';
const OpenRegistration = () => {

    const { campaignName,
        totalClasses,
        enrolmentType,
        enrolmentPeriod,
        startDateAndEndDate,
        spaceAvailable,
        spaceTaken,
        waitlisted,
        listOfOpenForRegistration,
        totalApplicants,
        enrolmentMethodLabel, } = useTranslationshome();

    const { selectedLanguage } = useLanguage();
    const { campaigns, loading, error } = useCampaignQuarterlyList('open_registration');
    const counts = useCampaignEnrollmentCounts(campaigns, 'open_registration');

    return (
        <div>
            <Row className="ps-4 pt-4 align-items-center">
                <Col>
                    <Breadcrumb routeSegments={[{ name: listOfOpenForRegistration() }]} />
                </Col>

            </Row>
            <table className="table table-striped mt-4">
                <thead>
                    <tr>
                        <th className="custom-th">{campaignName()}</th>
                        <th className="custom-th">{enrolmentType()}</th>
                        <th className="custom-th">{enrolmentPeriod()}</th>
                        <th className="custom-th">{startDateAndEndDate()}</th>
                        <th className="custom-th">{totalClasses()}</th>
                        <th className="custom-th">{totalApplicants()}</th>
                        <th className="custom-th">{waitlisted()}</th>
                        <th className="custom-th">{spaceTaken()}</th>
                        <th className="custom-th">{spaceAvailable()}</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td className="text-center" colSpan="9">Loading...</td></tr>
                    ) : error ? (
                        <tr><td className="text-center text-danger" colSpan="9">Failed to load campaigns</td></tr>
                    ) : campaigns.length === 0 ? (
                        <tr><td className="text-center" colSpan="9">No data</td></tr>
                    ) : (
                        campaigns.map((c) => {
                            const ec = counts[c.campaign_id] || {};
                            return (
                            <tr className="custom-td" key={c.campaign_id}>
                                <td>{localizedName(c.campaign_name, selectedLanguage)}</td>
                                <td>{enrolmentMethodLabel(c.campaign_enrolment_method)}</td>
                                <td>{formatRange(c.campaign_reg_start_date, c.campaign_reg_end_date)}</td>
                                <td>{formatRange(c.campaign_start_date, c.campaign_end_date)}</td>
                                <td>{cell(c.total_courses)}</td>
                                <td>{cell(ec.total_applicants)}</td>
                                <td>{cell(ec.total_waitlisted)}</td>
                                <td>{cell(ec.space_taken)}</td>
                                <td>{cell(ec.space_available)}</td>
                            </tr>
                            );
                        })
                    )}
                </tbody>
            </table></div>
    )
}

export default OpenRegistration
